import React, { useEffect } from "react";
import _ from "lodash";
import { compose } from "redux";
import { connect } from "react-redux";
import * as loaderAction from "../../../redux/loader/action";
import { withRouter } from "react-router-dom";

import { gameover_bg } from "../../../assets/images/fluster";

const Over = (props) => {
  const { parameters } = props;
  const game_over = _.get(parameters, "12_over.game_over", "GAME OVER");
  const info = _.get(
    parameters,
    "12_over.info",
    "Hope you got to know each other better."
  );

  const loaderTwoSec = () => {
    setTimeout(() => {
      props.setIsLoading(true);
    }, 3000);
    props.setIsLoading(false);
  };
  // useEffect(() => {
  //   props.setIsLoading(true);
  // }, []);
  return (
    <>
      <div className="game-over">
        <div className="timer-section">
          <img src={gameover_bg} alt="" className="user-border" />
          <h3>GAME OVER</h3>
        </div>
        <p>Hope you got to know each other better.</p>
      </div>
    </>
  );
};
const mapStateToProps = (state) => ({
  gameReducer: state.gameReducer,
  paramsReducer: state.paramsReducer,
});

const mapDispatchToProps = (dispatch) => {
  return {
    setIsLoading: (data) => dispatch(loaderAction.setIsLoading(data)),
  };
};

export default compose(
  withRouter,
  connect(mapStateToProps, mapDispatchToProps)
)(Over);
